import React from 'react';
import PropTypes from 'prop-types';
import { Components, translate } from 'versafleet-core';
import classNames from 'classnames';
import MobileGlobalSearchItem from './item';
import MobileGlobalSearchSeparator from './separator';

class MobileGlobalSearchDropdown extends React.Component {
  _renderResults() {
    if (this.props.tasks.length === 0 && this.props.jobs.length === 0) {
      return <MobileGlobalSearchItem data={null} />;
    }

    return (
      <div>
        <MobileGlobalSearchSeparator
          itemNumber={this.props.jobs.length}
          jobOrTask="Jobs"
        />
        {
          this.props.jobs.map(job => (
            <MobileGlobalSearchItem
              data={job}
              isJob
              key={`job-${job.id}`}
              onClick={this.props.onClickItem}
            />
          ))
        }
        <MobileGlobalSearchSeparator
          itemNumber={this.props.tasks.length}
          jobOrTask="Tasks"
        />
        {
          this.props.tasks.map(task => (
            <MobileGlobalSearchItem
              data={task}
              key={`task-${task.id}`}
              onClick={this.props.onClickItem}
            />
          ))
        }
      </div>
    );
  }

  _renderLoading() {
    return (
      <div className="vf-mobile-global-search__loading">
        <Components.EllipsisLoading />
        <div className="vf-mobile-global-search__loading__text">
          {this.props.strings.searching}
        </div>
      </div>
    );
  }

  render() {
    const className = classNames('vf-mobile-global-search__dropdown', this.props.className);
    return (
      <div className={className}>
        {this.props.isLoading ? this._renderLoading() : this._renderResults()}
      </div>
    );
  }
}

MobileGlobalSearchDropdown.displayName = 'Mobile Global Search Dropdown';

MobileGlobalSearchDropdown.propTypes = {
  className: PropTypes.string,
  isLoading: PropTypes.bool.isRequired,
  jobs: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number,
  })).isRequired,
  onClickItem: PropTypes.func.isRequired,
  strings: PropTypes.shape({
    searching: PropTypes.string,
  }).isRequired,
  tasks: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number,
  })).isRequired,
};

MobileGlobalSearchDropdown.defaultProps = {
  className: null,
};

export default translate('GlobalSearch')(MobileGlobalSearchDropdown);
